import { Component, Input } from '@angular/core';

import { Store } from '@ngrx/store';

import { VipDiscountListByCompanyResponse } from '@app/api/marketplace/models';
import { OrderListActions } from '@app/order-list/store/order-list.slice';
import { VipDiscountsActions } from '@app/vip-discounts/store/vip-discounts.slice';
import { cancellationMockDateHu } from '@shared/constants/cancellation-mock-date';

@Component({
  selector: 'app-vip-discounts-received-table',
  templateUrl: './vip-discounts-received-table.component.html',
  styleUrls: ['./vip-discounts-received-table.component.scss'],
})
export class VipDiscountsReceivedTableComponent {
  @Input() discount!: VipDiscountListByCompanyResponse;
  @Input() tableIndex!: number;
  @Input() showCaptionRow = false;

  cancellationMockDateHu = cancellationMockDateHu;

  constructor(private store: Store) {}

  showOriginalPrice(index: number) {
    this.store.dispatch(
      VipDiscountsActions.loadOriginalPrice.trigger({
        discount: this.discount.vipDiscountList![index],
        isRequestedAsDiscountReceiver: true,
      })
    );
  }

  addToOrderList(selected: Array<string>): void {
    this.store.dispatch(
      OrderListActions.addItems.trigger({
        request: {
          packagingUnitIds: selected,
        },
      })
    );
  }
}
